import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';
@Injectable({ providedIn: 'root' })
export class ClinicPatientService extends ApiService {
  endPoint = '/api/clinicPatients';
  get(id: string): Observable<any> {
    return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
  }
}
